export default __webpack_public_path__ + "navigation-examples-offline-regions-1200-a1e747510207e7384b29875d3fb89fd8.webp";